// Yakalanmayan Angular çalışma-zamanı hatalarını backend'in SystemErrorLog
// defterine bildirir (Source='frontend') — /admin/system-logs sayfasında
// sunucu hatalarıyla aynı listede görünür.
//
// Guard'lar: HTTP hataları atlanır (backend zaten kendi tarafında logladı),
// aynı imzalı hata oturum başına bir kez gönderilir (döngü/gürültü koruması),
// bildirim başarısız olursa sessizce yutulur (hata bildiriminin kendisi hata
// üretmemeli).
import { etiketMetni } from '@/app/domains/portal/core/etiket-ceviri';

import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { API_BASE } from '@/app/core/auth/auth.service';

const MAX_REPORTS_PER_SESSION = 20;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private http = inject(HttpClient);
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  private readonly reported = new Set<string>();
  private sentCount = 0;

  handleError(error: unknown): void {
    // Geliştiricinin konsolda görmesi her koşulda sürmeli.
    console.error(error);

    try {
      this.report(error);
    } catch {
      // Bildirim yolu asla uygulamayı bozmaz.
    }
  }

  private report(error: unknown): void {
    // SSR render'ında bu defter kullanılmaz: `window` yok, ve bir render hatası
    // için Node'dan API'ye istek atmak hatayı iki kez raporlamak olur (Express
    // zaten 500'ü loglar). Sunucu hataları .NET tarafında kaydediliyor.
    if (!this.isBrowser) return;
    if (error instanceof HttpErrorResponse) return;   // sunucu tarafı zaten logladı
    if (this.sentCount >= MAX_REPORTS_PER_SESSION) return;

    const err = error instanceof Error ? error : new Error(String(error));
    const message = err.message || etiketMetni('ui.bilinmeyenHata');
    const signature = `${err.name}:${message}`;
    if (this.reported.has(signature)) return;

    this.reported.add(signature);
    this.sentCount++;

    this.http.post(`${API_BASE}/platform/system-logs/client-error`, {
      message,
      errorType: err.name || 'FrontendError',
      stackTrace: err.stack ?? null,
      url: window.location.pathname + window.location.search,
    }).subscribe({
      error: () => { /* bildirim başarısız — sessizce geç */ },
    });
  }
}
